import request from '@/utils/request'

// 分页获取支付计划列表
export function getPaymentPlanPage(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/payment-plan/page',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增支付计划
export function savePaymentPlan(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/payment-plan/save',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新支付计划
export function updatePaymentPlan(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/payment-plan/update',
      method: 'put',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除支付计划
export function deletePaymentPlan(id) {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/payment-plan/delete/${id}`,
      method: 'delete'
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取支付计划详情
export function getPaymentPlanDetail(id) {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/payment-plan/get/${id}`,
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增支付记录
export function savePaymentRecord(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/payment-record/save',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}